export default __webpack_public_path__ + "96136c6aab7c0b476f9d8cac5e242e63.gif";